import React, { useEffect } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';

import { ItemForm, ViewFrame } from '../../components';
import { useTitle } from '../../hooks';
import VideoMenuTabs, { validationSchema } from './VideoMenuTabs';
import { Loadable } from '../../store/types';
import { VideoMenu } from '../../types/items';

type Props = {
  creatingMode?: boolean;
  record: Loadable<VideoMenu>;
  onSubmit: (data: VideoMenu) => void;
  getTitle?: () => string;
};

const VideoMenuDetails = ({
  creatingMode = false,
  record: { loading, data },
  onSubmit,
}: Props) => {
  const dispatch = useDispatch();
  const title = data?.title || 'New Video Menu';

  useTitle(title);

  useEffect(() => {
    const hotKeyList = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key?.toLocaleLowerCase() === 'l') {
        event.preventDefault();
        dispatch(push('/dashboard/admin/video-menus'));
      }
    };
    window.addEventListener('keydown', hotKeyList);

    return () => {
      window.removeEventListener('keydown', hotKeyList);
    };
  }, [dispatch]);

  return (
    <ViewFrame
      loading={loading}
      title={title}
      backToListLink
    >
      <ItemForm
        creatingMode={creatingMode}
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        loading={loading}
        editPermitted={Boolean(data?.permissions.can_edit)}
        enableReinitialize
        preventCancelChanges
        validateOnMount={false}
        validateOnBlur={false}
        validateOnChange
      >
        {VideoMenuTabs}
      </ItemForm>
    </ViewFrame>
  );
};

export default VideoMenuDetails;
